/**
 * First, we will load all of this project's Javascript utilities and other
 * dependencies. Then, we will be ready to develop a robust and powerful
 * application frontend using useful Laravel and JavaScript libraries.
 */

window.axios = require('axios');

import '@babel/polyfill';
import Vue from 'vue';
import '@fortawesome/fontawesome-pro/css/all.css';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import Vuetify, {
  VApp,
  VContainer,
  VLayout,
  VFlex,
  VContent,
  VNavigationDrawer,
  VFooter,
  VToolbar,
  VToolbarTitle,
  VToolbarSideIcon,
  VFadeTransition,
  VCard,
  VCardText,
  VCardTitle,
  VCardActions,
  VAlert,
  VBtn,
  VDialog,
  VAutocomplete,
  VSpacer,
  VIcon,
  VDivider,
  VExpandTransition,
  VList,
  VListGroup,
  VListTile,
  VListTileContent,
  VListTileTitle,
  VListTileSubTitle,
  VListTileAction,
  VListTileActionText,
  VListTileAvatar,
  VTextField,
  VSwitch,
  VSelect,
  VTextarea,
  VCheckbox,
  VImg,
  VChip,
  VHover,
  VProgressLinear,
  VTabs,
  VTab,
  VTabsItems,
  VTabItem,
  VSnackbar,
  VSlideYTransition,
  VSubheader,
  VSystemBar,
  VAvatar,
  VExpansionPanel,
  VExpansionPanelContent,
  VTooltip,
} from 'vuetify/lib';
import { Ripple } from 'vuetify/lib/directives';
import Meta from 'vue-meta';
import VeeValidate from 'vee-validate';
import store from './store/store';
import router from './router/index';
import { sync } from 'vuex-router-sync';

import './utils/filters';
import App from './App.vue';
import BackToTop from 'vue-backtotop';
import AppDate from './components/AppDate';
import AppSocialShare from './components/AppSocialShare';
import { initialize } from './api/general';

Sentry.init({
  dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
});

Vue.prototype.$appName = 'PR Properties Group';

Vue.use(Meta);
Vue.use(Vuetify, {
  iconfont: 'fa',
  components: {
    VApp,
    VContainer,
    VLayout,
    VFlex,
    VContent,
    VNavigationDrawer,
    VFooter,
    VToolbar,
    VToolbarTitle,
    VToolbarSideIcon,
    VFadeTransition,
    VCard,
    VCardText,
    VCardTitle,
    VCardActions,
    VAlert,
    VBtn,
    VDialog,
    VAutocomplete,
    VSpacer,
    VIcon,
    VDivider,
    VExpandTransition,
    VList,
    VListGroup,
    VListTile,
    VListTileContent,
    VListTileTitle,
    VListTileSubTitle,
    VListTileAction,
    VListTileActionText,
    VListTileAvatar,
    VTextField,
    VSwitch,
    VSelect,
    VTextarea,
    VCheckbox,
    VImg,
    VChip,
    VHover,
    VProgressLinear,
    VTabs,
    VTab,
    VTabsItems,
    VTabItem,
    VSnackbar,
    VSlideYTransition,
    VSubheader,
    VSystemBar,
    VAvatar,
    VExpansionPanel,
    VExpansionPanelContent,
    VTooltip,
  },
  directives: {
    Ripple,
  },
});
Vue.use(VeeValidate, { events: 'change' });
Vue.use(BackToTop);

// if (process.env.NODE_ENV !== 'production') {
//   const VueAxe = require('vue-axe');
//   Vue.use(VueAxe, {
//     clearConsoleOnUpdate: true,
//     config: {
//       rules: [
//         { id: 'heading-order', enabled: true },
//         { id: 'label-title-only', enabled: true },
//         { id: 'link-in-text-block', enabled: true },
//         { id: 'region', enabled: true },
//         { id: 'skip-link', enabled: true },
//         { id: 'help-same-as-label', enabled: true },
//       ],
//     },
//   });
// }

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production';

Vue.component('AppDate', AppDate);
Vue.component('AppSocialShare', AppSocialShare);

initialize(store, router);

sync(store, router);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
